module.exports = __webpack_public_path__ + "static/media/instagram-colored.d8ed35bf.svg";